import { HttpStatusCode } from "../../core/services/protocols/types";

type ContabilResponseError = { message: string };

export interface IDefaultContabilResponse<T> {
  code: HttpStatusCode;
  result: T;
  errors?: ContabilResponseError[];
}

export interface IContabilPagination<T> {
  pageIndex: number;
  pageSize: number;
  totalPages: number;
  totalItems: number;
  items: T[];
}

export interface IContabilPaginationFilter {
  page?: number;
  qtd?: number;
}

export interface IDateRangeParams {
  start: string;
  end: string;
}

export enum ContabilDITypes {
  DASHBOARD_GATEWAY = "CONTABIL_DASHBOARD_GATEWAY",
  DIAGNOSTICO_GATEWAY = "CONTABIL_DIAGNOSTICO_GATEWAY",
  SHARED_GATEWAY = "CONTABIL_SHARED_GATEWAY",
  DASHBOARD_LUCRO_GATEWAY = "CONTABIL_DASHBOARD_LUCRO_GATEWAY",
  OBRIGACOES_SHORTCUTS = "OBRIGACOES_SHORTCUTS",
  CONTABIL_SHORTCUTS = "CONTABIL_SHORTCUTS",
  AUTOCONTRATACAO_GATEWAY = "AUTOCONTRATACAO_GATEWAY",
  CONTROLE_DEBITOS_GATEWAY = "CONTROLE_DEBITOS_GATEWAY",
  CONTROLE_DEBITOS_POR_EMPRESA_GATEWAY = "CONTROLE_DEBITOS_POR_EMPRESA_GATEWAY",
  MOSTRAR_CONTROLE_DEBITOS_GATEWAY = "MOSTRAR_CONTROLE_DEBITOS_GATEWAY"
}
